import { makeStyles } from '@material-ui/core/styles'
import { PieChart, Pie, Legend, Tooltip, Cell } from 'recharts'
import { number, shape } from 'prop-types'

const styles = makeStyles({
  centerDiv: {
    margin: 'auto',
    padding: '10px',
    textAlign: 'center',
  },
})

const ResponseChart = (props) => {
  const classes = styles()
  const { unique_response_summary } = props

  // Create variables from values of matching keys
  let toRender2 = <br />

  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042']
  const RADIAN = Math.PI / 180
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index,
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.15
    const x = cx + radius * Math.cos(-midAngle * RADIAN)
    const y = cy + radius * Math.sin(-midAngle * RADIAN)

    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > cx ? 'start' : 'end'}
        dominantBaseline="central"
      >{`${(percent * 100).toFixed(0)}%`}</text>
    )
  }
  const renderLegend = (props) => {
    const { payload } = props
    return (
      <ul style={{ padding: '0px', margin: '0px', textAlign: 'left' }}>
        {payload.map((entry, index) => (
          <li
            key={`item-${index}`}
            style={{ display: 'inline-block', marginRight: '10px' }}
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 32 32"
              version="1.1"
              style={{
                display: 'inline-block',
                verticalAlign: 'middle',
                marginRight: '4px',
              }}
            >
              <path
                stroke="none"
                fill={COLORS[index % COLORS.length]}
                d="M0,4h32v24h-32z"
              />
            </svg>
            <span>
              {entry.value}: {entry.payload.value}
            </span>
          </li>
        ))}
      </ul>
    )
  }

  let totalPositiveResponses =
    Number(unique_response_summary['email_response_positive']) +
    Number(unique_response_summary['phone_response_positive']) +
    Number(unique_response_summary['sms_response_positive'])
  let totalNegativeResponses =
    Number(unique_response_summary['email_response_negative']) +
    Number(unique_response_summary['phone_response_negative']) +
    Number(unique_response_summary['sms_response_negative'])
  let chartData = []
  if (totalPositiveResponses > 0) {
    chartData.push({ name: 'Safe', value: totalPositiveResponses })
  }
  if (totalNegativeResponses > 0) {
    chartData.push({ name: 'Follow Up', value: totalNegativeResponses })
  }
  if (Number(unique_response_summary['no_response']) > 0) {
    chartData.push({
      name: 'No Response',
      value: Number(unique_response_summary['no_response']),
    })
  }
  toRender2 = (
    <PieChart width={200} height={200} className={classes.centerDiv}>
      <Pie
        isAnimationActive={false}
        data={chartData}
        innerRadius={30}
        outerRadius={80}
        fill="#8884d8"
        labelLine={false}
        label={renderCustomizedLabel}
        nameKey="name"
        dataKey="value"
      >
        {chartData.map((entry, index) => (
          <Cell key={entry} fill={COLORS[index % COLORS.length]} />
        ))}
      </Pie>
      <Legend content={renderLegend} verticalAlign="top" height={36} />
      <Tooltip />
    </PieChart>
  )

  return <div>{toRender2}</div>
}

export default ResponseChart

ResponseChart.propTypes = {
  unique_response_summary: shape({
    email_response_positive: number,
    email_response_negative: number,
    phone_response_positive: number,
    phone_response_negative: number,
    sms_response_positive: number,
    sms_response_negative: number,
    no_response: number,
  }),
}
